import axios from 'axios';
import { present } from '@/shared/utils/typescript';
import AuthenticationMethod from '../constants/AuthenticationMethod';
import { parseAuthenticationResult } from '../converters/authenticationResultConverters';
import { parseIdentity } from '../converters/identityConverters';
import AuthenticationResult from '../models/AuthenticationResult';
import Identity from '../models/Identity';
import { AzureAccessToken } from '../services/AzureAuthService';

export default class AuthClient {
  static async getAuthenticationMethod(username: string): Promise<AuthenticationMethod> {
    const response = await axios.get(`/api/mobopro/v1/authenticationtype?email=${username}`);
    return response.data.type;
  }

  static async authenticate(username: string, password: string): Promise<AuthenticationResult> {
    const response = await axios.post('/api/mobopro/v1/authenticate', { username, password });
    return present(parseAuthenticationResult(response.data));
  }

  static async authenticateWithAzure(token: AzureAccessToken): Promise<AuthenticationResult> {
    const response = await axios.post('/api/mobopro/v1/authenticate/ad', { token });
    return present(parseAuthenticationResult(response.data));
  }

  static updatePassword(password: string): Promise<void> {
    return axios.put('/api/mobopro/v1/updatepassword', { password });
  }

  static async getCurrentIdentity(): Promise<Identity> {
    const response = await axios.get('/api/mobopro/v1/currentidentity');
    return present(parseIdentity(response.data));
  }
}
